import { render, staticRenderFns } from "./showConvocationFormV3.vue?vue&type=template&id=538ff7db"
import script from "./showConvocationFormV3.vue?vue&type=script&lang=js"
export * from "./showConvocationFormV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports